import { FunctionComponent, useMemo } from 'react';
import { PaymentMethod } from '@shared/types';
import styles from '../styles.module.scss';
import { SPREADABLE_PAYMENT_METHODS } from '..';

export const Label: FunctionComponent<{ enabledPaymentOptions: Array<PaymentMethod> }> = ({
    enabledPaymentOptions,
}) => {
    const spreadTheCostLabel: string = useMemo(() => {
        if (
            SPREADABLE_PAYMENT_METHODS.every((paymentMethod: PaymentMethod) =>
                enabledPaymentOptions.includes(paymentMethod)
            )
        ) {
            return 'Available at Checkout';
        }
        if (enabledPaymentOptions.includes('klarna')) {
            return 'Available at Checkout';
        }
        if (enabledPaymentOptions.includes('paypal')) {
            return 'Pay in 3 available at checkout';
        }
        return 'Spread the cost unavailable';
    }, [enabledPaymentOptions]);

    return <div className={styles.heading}>{spreadTheCostLabel}</div>;
};
